<template>
  <div>
    <nav
      v-if="cantidad > cantidadPorPagina"
      aria-label="Paginación"
      id="paginacion"
    >
      <ul class="pagination justify-content-center">
        <!--Anterior-->
        <li
          v-if="indice > 1"
          class="page-item d-none d-sm-block"
          v-on:click="irAPagina(indice - 1)"
        >
          <!--Anterior se muestra en pantallas grandes-->
          <a class="page-link d-none d-md-block">Anterior</a>
          <!--Flecha se muestra en pantallas chicas-->
          <a class="page-link d-md-none" aria-label="Anterior">
            <span aria-hidden="true">&laquo;</span>
          </a>
        </li>
        <li
          v-for="i in this.paginas"
          :key="i"
          class="page-item"
          v-bind:class="{ active: i === indice }"
          v-on:click="irAPagina(i)"
        >
          <a class="page-link">{{ i }}</a>
        </li>
        <!--Siguiente-->
        <li
          v-if="!EstoyEnUltimaPagina"
          class="page-item d-none d-sm-block"
          v-on:click="irAPagina(indice + 1)"
        >
          <!--Siguiente se muestra en pantallas grandes-->
          <a class="page-link d-none d-md-block">Siguiente</a>
          <!--Flecha se muestra en pantallas chicas-->
          <a class="page-link d-md-none" aria-label="Siguiente">
            <span aria-hidden="true">&raquo;</span>
          </a>
        </li>
      </ul>
    </nav>
  </div>
</template>
<script>
import { Paginacion as Constantes } from "../constants";
import { Util } from "../util";

export default {
  name: "Paginacion",
  props: {
    cantidad: Number,
    cantidadPorPagina: {
      type: Number,
      default: 20,
    },
    /**Página inicial en la que empezará la paginación,
     * también es usado para actualizar el índice cuando se cambia
     * ya que se le hace un watch
     */
    paginaInicial: Number,
  },
  data() {
    return {
      indice: 1,
      paginas: [],
    };
  },
  computed: {
    CantidadActualDePaginas() {
      return this.paginas.length;
    },
    /** Posición desde la cual se está mostrando */
    Desde() {
      return Util.paginacionCalcularDesde(this.indice, this.cantidadPorPagina);
    },
    EstoyEnUltimaPagina() {
      return (
        this.paginas == null ||
        this.paginas.length < 1 ||
        this.paginas[this.paginas.length - 1] == this.indice
      );
    },
    Hasta() {
      return Util.paginacionCalcularHasta(this.indice, this.cantidadPorPagina);
    },
  },
  watch: {
    cantidad(nueva, vieja) {
      if (nueva === vieja) return;

      const nuevaCantidadDePaginas = this.cantidadDePaginas(
        nueva,
        this.cantidadPorPagina
      );

      // Si el índice quedó apuntando a una página que ya no existe
      if (this.indice > nuevaCantidadDePaginas) {
        // Ir a la página anterior ya que esta no existe
        this.irAPagina(this.indice - 1);
      } else {
        // IrAPagina ya realiza un ajustarPaginas, por lo que si no se fue
        // a una página (no cambió el índice) ajustarlas acá si cambia la cantidad de páginas
        if (nuevaCantidadDePaginas != this.CantidadActualDePaginas) {
          this.ajustarPaginas();
        }
      }
    },
    cantidadPorPagina(nueva, vieja) {
      if (nueva === vieja) return;

      this.ajustarPaginas();
    },
    paginaInicial() {
      this.indice = this.paginaInicial;
    },
  },
  methods: {
    /** Calcula y devuelve la cantidad de páginas que se deberían mostrar */
    cantidadDePaginas(cantidad, cantidadPorPagina) {
      return Math.ceil(cantidad / cantidadPorPagina);
    },
    ajustarPaginas() {
      const cantidadDePaginas = this.cantidadDePaginas(
        this.cantidad,
        this.cantidadPorPagina
      );

      if (cantidadDePaginas > 1) {
        const paginasAMostrar = Math.min(
          cantidadDePaginas,
          Constantes.MAX_PAGINAS_MOSTRADAS
        );

        const cantidadALosLados = Math.floor(paginasAMostrar / 2);

        // Página actual está cerca de la izquierda
        let inicio = 1;

        // Página actual en el centro
        if (this.indice > cantidadALosLados)
          inicio = this.indice - cantidadALosLados;

        // Página actual está cerca de la derecha
        if (this.indice + cantidadALosLados >= cantidadDePaginas)
          inicio = cantidadDePaginas - paginasAMostrar + 1;

        if (this.paginas == null || this.paginas.length != paginasAMostrar) {
          // Solo recrear cuando cambian la acntidad de páginas que se muestran, o la primera vez
          this.paginas = new Array(paginasAMostrar);
        }

        for (let i = 0; i < paginasAMostrar; i++) {
          this.paginas[i] = i + inicio;
        }
      } else {
        // No mostrar paginación cuando hay solo una página
        this.paginas = [];
      }
    },
    irAPagina(numero) {
      this.indice = numero;
      this.ajustarPaginas();

      this.$emit("pagina-cambiada", numero);
    },
  },
  mounted() {
    if (this.paginaInicial != null) this.indice = this.paginaInicial;
  },
};
</script>
<style scoped>
.pagination {
  --color-paginado: black;
}

#paginacion {
  padding-top: 2em;
  padding-bottom: 1em;
}

.pagination > li > a,
.pagination > li > span {
  border-color: var(--color-paginado);
  color: var(--color-paginado);
}
.pagination > li.active > a {
  /* background: var(--color-paginado); */
  background: var(--color-estructura-a);
  color: #fff;
}

.page-item.active .page-link {
  border-color: var(--color-paginado);
}
.page-link {
  cursor: pointer;
  margin-left: 0px;
}

.page-item a:hover {
  background: var(--color-estructura-c);
}
</style>
